import { gql } from '@apollo/client'

export const OverviewQuery = gql`
  query Overview($companyId: ID!, $eventFilters: EventFilters, $userFilters: CompanyUserFilters) {
    events(companyId: $companyId, filters: $eventFilters) {
      nodes {
        id
        dateOut
      }
    }

    companyUsers(companyId: $companyId, filters: $userFilters) {
      nodes {
        id
        acceptedAt
      }
    }
  }
`
